import { Box, Typography, Grid } from '@mui/material';
import homeHero from '../assets/images/home-hero.png';
import HeaderWithBar from './HeaderWithBar';

const InnovativeSolutions = () => (
  <Box sx={{ py: {xs: 5, md: 15}, px: { xs: 4, md: 20}, display: 'flex', textAlign: "left", gap: '20px', flexDirection: { xs: 'column-reverse', md: 'row' },  }}>
    <Box sx={{ flex: '1 1', my: 'auto' }}>
    <HeaderWithBar text="Quality" />
    <Typography variant="h3" gutterBottom sx={{ lineHeight: "60px"}} >
      Innovative Solutions for Sustainable Production
    </Typography>
    <Typography variant="subtitle1" sx={{ maxWidth: 800, mx: 'auto', mb: 4 }}>
    At Vivek Bio Products, we specialize in high-quality grain-based Bio Fuel and by-products. Our commitment to sustainability drives us to create solutions that benefit both industry and environment.
    </Typography>
    <Grid container spacing={4}>
      <Grid item xs={12} md={6}>
        <Typography variant="h6">Ethyl Alcohol</Typography>
        <Typography variant="subtitle1">
        Pure, versatile Bio Fuel for various industrial applications and consumer products.
        </Typography>
      </Grid>
      <Grid item xs={12} md={6}>
        <Typography variant="h6">Animal Feed</Typography>
        <Typography variant="subtitle1">
        Nutritious feed solutions designed to enhance livestock health and productivity.
        </Typography>
      </Grid>
    </Grid>
    </Box>
    <Box sx={{ flex: '1 1' }}>
    <img src={homeHero} alt="Innovative Solutions" style={{ width: '100%', height: 'auto' }} />
    </Box>
  </Box>
);

export default InnovativeSolutions;
